module.exports = __webpack_public_path__ + "img/ita.8d15de04.svg";